var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 60,
    rx: 5,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA1MCA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjYwIiByeD0iNSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMTAiIHk9IjE2IiB3aWR0aD0iMjIiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPHJlY3QgeD0iMTAiIHk9IjIyIiB3aWR0aD0iMTYiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPHJlY3QgeD0iMTAiIHk9IjEwIiB3aWR0aD0iMzAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPC9zdmc+Cg==";
export { SvgCertificate as ReactComponent };